import { Box } from '@chakra-ui/react';
import { ErrorMessage, Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import * as yup from 'yup';

import {
  addDataStepOneFormSignleDataPeriod,
  handleActionStepNext,
  resetDataPeriodValuesForSingleType,
} from 'redux/DataImportSlice';

import ActionStepFooter from '../../ActionStepFooter';
import { FieldError, FieldLabel, StepFooterRow } from '../../actionStepUi';
import DataDatePicker from '../DataDatePicker';

interface Properties {
  setHelpModalSeleceted: any;
  getFormValue: any;
}
const validationSchema = yup.object().shape({
  selectedStartDate: yup.string().trim().required('This is field required'),
});

const Single = ({ getFormValue }: Properties) => {
  const dispatch: any = useDispatch();
  const [startIn, setStartIn] = useState<string>(getFormValue?.startDate ?? '');
  const handleClearSelection = () => {
    setStartIn('');
  };
  const handleSubmit = async (form: any, setSubmitting: (data: boolean) => void) => {
    await dispatch(addDataStepOneFormSignleDataPeriod(form));
    if (getFormValue?.dataPeriod === '1') {
      await dispatch(resetDataPeriodValuesForSingleType());
    }
    setSubmitting(false);
    dispatch(handleActionStepNext());
  };
  return (
    <Formik
      initialValues={{
        selectedStartDate: getFormValue?.startDate ? new Date(getFormValue?.startDate) : '',
      }}
      validationSchema={validationSchema}
      onSubmit={(form, { setSubmitting }) => handleSubmit(form, setSubmitting)}
      enableReinitialize={true}
    >
      {({ isSubmitting, setFieldValue }: any) => (
        <Form style={{ width: '100%' }}>
          <Box mt={4}>
            <FieldLabel>Select the dates for your data</FieldLabel>
            <DataDatePicker
              clearSection={false}
              clearDateInput={handleClearSelection}
              selected={startIn ? new Date(startIn) : null}
              onChange={(date: Date) => {
                setStartIn(date.toDateString());
                setFieldValue('selectedStartDate', date.toDateString());
              }}
              timescale={'M'}
            />
            <ErrorMessage name='selectedStartDate' component={FieldError} />
          </Box>

          <StepFooterRow>
            <ActionStepFooter
              nextButtonName='Continue'
              prevButtonName='Previous'
              isSubmitting={isSubmitting}
            />
          </StepFooterRow>
        </Form>
      )}
    </Formik>
  );
};

export default Single;
